import React from "react";
import { useIntl } from 'react-intl';
import messages from "../../locale/jsonMessages";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';

import cs from '../../components/commonStyle.css';


const ChangePlanModalBody = () => {
    const { formatMessage } = useIntl();
    return (
        <div>
            <p className={cx(cs.commonSmallText16, cs.spaceBottom2)}>{formatMessage(messages.cancelPlanModalTitle)}</p>
            <p className={cx(cs.commonSmallText16, cs.spaceBottom4)}>{formatMessage(messages.cancelPlanModalLabel01)}</p>
            <p className={cx(cs.commonSmallText16, cs.fontWeightBold, cs.spaceBottom2)}>{formatMessage(messages.cancelPlanModalLabel02)}</p>
            <ul className={cx(cs.commonSmallText16, cs.bulletList, cs.noMargin, cs.dFlexColumn, cs.gap6)}>
                <li>{formatMessage(messages.cancelPlanModalLabel03)}</li>
                <li>{formatMessage(messages.cancelPlanModalLabel04)}</li>
                <li>{formatMessage(messages.cancelPlanModalLabel05)}</li>
            </ul>
        </div>
    )
}

export default withStyles(cs)(ChangePlanModalBody);
